import { render, staticRenderFns } from "./CategoryProductList.vue?vue&type=template&id=0333149e&name=product-list&"
import script from "./CategoryProductList.vue?vue&type=script&lang=js&"
export * from "./CategoryProductList.vue?vue&type=script&lang=js&"
import style0 from "./CategoryProductList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports